import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Table,
  Card,
  Tag,
  Tooltip,
  Input,
  Button,
  Select,
  Row,
  Col,
} from "antd";
import * as XLSX from "xlsx";
import { req_list_pim_staff_leave_log } from "../../api";
import { usrRole } from "../../utils/dataUtil";

const LEAVE_TYPE_COLOR = {
  事假: "blue",
  家庭照顧假: "blue",
  病假: "orange",
  生理假: "orange",
  休假: "green",
  遞延休假: "cyan",
  補休: "cyan",
  補休假: "cyan",
  公假: "geekblue",
  公差: "geekblue",
  "公假(行政研習)": "geekblue",
  差假: "geekblue",
  婚假: "red",
  喪假: "red",
  娩假: "magenta",
  產檢假: "magenta",
  陪產檢及陪產假: "magenta",
  流產假: "magenta",
  產前假: "magenta",
  骨髓或器官捐贈假: "magenta",
};

class StaffLeaveLogSearch extends Component {
  state = {
    loading: false,
    deviceWidth: window.innerWidth,
    data: [],
    total: 0,
    searchField: "STAFFCODE",
    searchValue: "",
    userLevel: "NORMAL",
    leaveTypeFilter: "",
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.init_columns();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => this.setState({ deviceWidth: window.innerWidth });

  handle_search = () => {
    const { searchValue } = this.state;
    if (!searchValue.trim()) {
      this.setState({ searchField: "STAFFCODE" }, this.api_item_list);
    } else {
      this.api_item_list();
    }
  };

  handle_search_clear = () => {
    this.setState(
      { searchField: "STAFFCODE", searchValue: "" },
      this.api_item_list,
    );
  };

  // 遠端數據處理 ///////////////////////////////////////////////
  api_item_list = async () => {
    const { searchField, searchValue } = this.state;
    const { token, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_pim_staff_leave_log(
      searchField,
      searchValue,
      token,
    );
    if (result && result.total > 0) {
      //console.log(result);
      this.setState({ data: result.data, total: result.total, loading: false });
    } else {
      this.setState({ data: [], total: 0, loading: false });
    }
  };

  // 格式化工具 ////////////////////////////////////////////////
  convertToWorkDaysPadded = (value) => {
    if (value === null || value === undefined || value === "") return "--";
    const parts = String(value).split(",");
    const days = parseInt(parts[0], 10) || 0;
    const hours = parseInt(parts[1], 10) || 0;
    if (days === 0 && hours === 0) return "--";
    const d = days.toString().padStart(2, "0");
    const h = hours.toString().padStart(2, "0");
    return `${d}日${h}時`;
  };

  renderStatusTags = (item) => {
    const { IsInvalid, IsDisagree, IsTakeEffect } = item;
    if (IsInvalid) return <Tag color="gray">作廢</Tag>;
    if (IsDisagree) return <Tag color="red">不同意</Tag>;
    if (IsTakeEffect) return <Tag color="green">已生效</Tag>;
    return <Tag color="blue">未生效</Tag>;
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "假別",
        dataIndex: "LeaveType",
        key: "LeaveType",
        align: "center",
        width: 110,
        render: (text) => (
          <Tag color={LEAVE_TYPE_COLOR[text] || "default"}>{text || "--"}</Tag>
        ),
      },
      {
        title: "狀態",
        key: "status",
        align: "center",
        width: 80,
        render: (item) => this.renderStatusTags(item),
      },
      {
        title: "申請日",
        dataIndex: "ApplyDate",
        key: "ApplyDate",
        align: "center",
        width: 100,
        render: (text) => (text ? text.substring(0, 10) : "--"),
      },
      {
        title: "開始時間",
        dataIndex: "StartDatetime",
        key: "StartDatetime",
        align: "center",
        width: 140,
        render: (text) => {
          if (!text) return "--";
          const s = text.substring(0, 15).replace("T", "").replace(/-/g, "/");
          const date = s.substring(0, 10);
          const time = s.substring(10);
          return (
            <span>
              {date} <span style={{ color: "#cf1322" }}>{time}</span>
            </span>
          );
        },
      },
      {
        title: "結束時間",
        dataIndex: "EndDatetime",
        key: "EndDatetime",
        align: "center",
        width: 140,
        render: (text) => {
          if (!text) return "--";
          const s = text.substring(0, 15).replace("T", "").replace(/-/g, "/");
          const date = s.substring(0, 10);
          const time = s.substring(10);
          return (
            <span>
              {date} <span style={{ color: "#cf1322" }}>{time}</span>
            </span>
          );
        },
      },
      {
        title: "時數",
        dataIndex: "LeaveDayHours",
        key: "LeaveDayHours",
        align: "center",
        width: 80,
        render: (val) => {
          const formatted = this.convertToWorkDaysPadded(val);
          const isPositive = formatted !== "--";
          return (
            <span
              style={isPositive ? { color: "#1565c0", fontWeight: "bold" } : {}}
            >
              {formatted}
            </span>
          );
        },
      },
      {
        title: "部門",
        dataIndex: "DeptName",
        key: "DeptName",
        align: "center",
        width: 100,
        render: (text) => text || "--",
      },
      {
        title: "申請人",
        key: "staff",
        align: "center",
        width: 110,
        render: (item) => (
          <span>
            <span style={{ color: "#1565c0", marginRight: 4 }}>
              {item.StaffCode}
            </span>
            {item.StaffName}
          </span>
        ),
      },
      {
        title: "原因",
        dataIndex: "Reason",
        key: "Reason",
        ellipsis: true,
        render: (text) =>
          text ? (
            <Tooltip title={text}>
              <span>{text}</span>
            </Tooltip>
          ) : (
            "--"
          ),
      },
    ];
  };

  getFilteredData = () => {
    const { data, leaveTypeFilter } = this.state;
    const LEAVE_FILTER_TYPES = {
      PERSONAL: ["事假", "家庭照顧假"],
      COMPTIME:  ["補休", "補休假"],
      PUBLIC:    ["公假", "公差", "差假"],
      SICK:      ["病假", "生理假"],
    };
    return leaveTypeFilter && LEAVE_FILTER_TYPES[leaveTypeFilter]
      ? data.filter((d) => LEAVE_FILTER_TYPES[leaveTypeFilter].includes(d.LeaveType))
      : data;
  };

  handle_export_excel = () => {
    const rows = this.getFilteredData().map((item) => ({
      假別: item.LeaveType || "",
      狀態: item.IsInvalid
        ? "作廢"
        : item.IsDisagree
          ? "不同意"
          : item.IsTakeEffect
            ? "已生效"
            : "未生效",
      申請日: item.ApplyDate ? item.ApplyDate.substring(0, 10) : "",
      開始時間: item.StartDatetime
        ? item.StartDatetime.substring(0, 15)
            .replace("T", " ")
            .replace(/-/g, "/")
        : "",
      結束時間: item.EndDatetime
        ? item.EndDatetime.substring(0, 15).replace("T", " ").replace(/-/g, "/")
        : "",
      時數: this.convertToWorkDaysPadded(item.LeaveDayHours),
      部門: item.DeptName || "",
      職號: item.StaffCode || "",
      申請人: item.StaffName || "",
      原因: item.Reason || "",
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "請假記錄");
    XLSX.writeFile(wb, "請假申請記錄.xlsx");
  };

  handle_print = () => {
    window.print();
  };

  render() {
    const {
      loading,
      data,
      total,
      deviceWidth,
      searchField,
      searchValue,
      leaveTypeFilter,
    } = this.state;
    const isMobile = deviceWidth < 768;
    const displayData = this.getFilteredData();

    return (
      <Card
        title="請假申請記錄查詢"
        size="small"
        extra={
          <span style={{ color: "#888", fontSize: 12 }}>共 {total} 筆</span>
        }
      >
        <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
          <Col>
            <Select
              value={searchField}
              style={{ width: 90 }}
              onChange={(val) =>
                this.setState({ searchField: val, searchValue: "" })
              }
            >
              <Select.Option value="STAFFCODE">職號</Select.Option>
              <Select.Option value="STAFFNAME">姓名</Select.Option>
            </Select>
          </Col>
          <Col flex="auto">
            <Input
              allowClear
              placeholder={
                searchField === "STAFFCODE" ? "輸入職號" : "輸入姓名"
              }
              value={searchValue}
              style={{ maxWidth: 220 }}
              onChange={(e) => this.setState({ searchValue: e.target.value })}
              onPressEnter={this.handle_search}
            />
          </Col>
          {data.length > 0 && (
            <Col>
              <Select
                value={leaveTypeFilter}
                style={{ width: 130 }}
                onChange={(val) => this.setState({ leaveTypeFilter: val })}
              >
                <Select.Option value="">全部假別</Select.Option>
                <Select.Option value="PERSONAL">事假／家庭照顧假</Select.Option>
                <Select.Option value="COMPTIME">補休／補休假</Select.Option>
                <Select.Option value="PUBLIC">公假／公差／差假</Select.Option>
                <Select.Option value="SICK">病假／生理假</Select.Option>
              </Select>
            </Col>
          )}
          <Col>
            <Button
              type="primary"
              onClick={this.handle_search}
              loading={loading}
            >
              查詢
            </Button>
          </Col>
          {/* <Col>
            <Button onClick={this.handle_search_clear}>清除</Button>
          </Col> */}
          <Col>
            <Button
              onClick={this.handle_export_excel}
              disabled={data.length === 0}
            >
              匯出
            </Button>
          </Col>
          {/* <Col>
            <Button onClick={this.handle_print} disabled={data.length === 0}>
              列印
            </Button>
          </Col> */}
        </Row>
        <Table
          rowKey="Id"
          size={isMobile ? "small" : "middle"}
          loading={loading}
          columns={this.columns}
          dataSource={displayData}
          scroll={{ x: 900 }}
          pagination={{
            pageSize: 15,
            showSizeChanger: false,
            showTotal: (t) => `共 ${t} 筆`,
          }}
          rowClassName={(record) => {
            if (record.IsInvalid) return "row-invalid";
            if (record.IsDisagree) return "row-disagree";
            return "";
          }}
        />
        <style>{`
          .row-invalid td  { color: #bbb !important; text-decoration: line-through; }
          .row-disagree td { color: #cf1322 !important; }
          @media print {
            body > *:not(#root) { display: none; }
            .ant-card-head-title { font-size: 16px; font-weight: bold; }
            .ant-btn, .ant-select, .ant-input, .ant-row { display: none !important; }
            .ant-table-pagination { display: none !important; }
            .ant-card { box-shadow: none !important; border: none !important; }
          }
        `}</style>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user });
export default connect(mapStateToProps)(StaffLeaveLogSearch);
